import { untrack } from 'solid-js';
import { getFieldAndArrayStores } from './getFieldAndArrayStores';
/**
 * Updates the invalid state of the form.
 *
 * @param form The store of the form.
 * @param dirty Whether there is an error.
 */
export function updateFormInvalid(form, invalid) {
    untrack(() => {
        form.internal.invalid.set(invalid ||
            getFieldAndArrayStores(form).some((fieldOrFieldArray) => fieldOrFieldArray.active.get() && fieldOrFieldArray.error.get()));
    });
}
